import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  children?: ReactNode;
}

const EmptyState: FC<EmptyStateProps> = ({ children }) => {
  const { t } = useTranslation();
  return (
    <div className='mex:w-full mex:py-6 mex:text-center mex:text-gray-400'>
      {children ?? t('conversations.empty.noData')}
    </div>
  );
};

export default EmptyState;
